export default {
  login: {
    title: 'Přihlášení',
    username: 'Uživatelské jméno',
    password: 'Heslo',
    login: 'Přihlásit',
    unknownError: 'Došlo k chybě, zkuste to prosím později',
    badCredentialsError: 'Špatné jméno nebo heslo',
    forgotten: 'Zapomenuté heslo'
  },
  dashboard: {
    lastRecordings: 'Poslední nahrávky',
    moreRecordings: 'Další nahrávky',
    systemStorageUsage: 'Využití systémového místa',
    logicStorageUsage: 'Využití místa',
    notifications: 'Notifikace'
  },
  pageNotFound: {
    title: '404',
    pageNotFound: 'Stránka nenalezena'
  },
  recordings: {
    recordingIsEncrypted: 'Nahrávka je šifrovaná',
    downloadSelected: 'Stáhnout vybrané',
    play: 'Přehrát',
    download: 'Stáhnout',
    downloadMetadata: 'Stáhnout metadata',
    archived: 'Nahrávka je archivována',
    delete: 'Smazat nahrávku',
    deleteSelected: 'Smazat vybrané nahrávky',
    deletePrompt: 'Pro potvrzení smazání nahrávky zadejte slovo DELETE',
    deleteSelectedPrompt: 'Pro potvrzení smazání vybraných nahrávek zadejte slovo DELETE SELECTED',
    downloading: 'Stahování nahrávek',
    requestDownload: 'Vyžádat stažení',
    requestPlay: 'Vyžádat přehrání',
    requestDelete: 'Vyžádat smazání',
    actionRequest: 'Vytvořit žádost',
    requestQuestion: 'Chcete vyžádat danou operaci?',
    reason: {
      unknown: 'Nahrávka nebyla nahrána.',
      timeMismatch: 'Mimo časové okno.',
      recordingDisabled: 'Nahrávání vypnuto.',
      numberBlacklist: 'Číslo {number} je v blacklistu.'
    },
    deleteFiltered: 'Smazat vše',

    deleteFilteredPrompt: 'Pokud opravdu chcete smazat {number} nahrávek odpovídajících aktuálnímu filtru, zadejte slovo DELETE FILTERED',
    deleting: 'Mazání'
  },
  profile: {
    loading: 'Načítání profilu',
    accesses: {
      title: 'Přístupy'
    },
    certForm: {
      titleAdd: 'Přidat klíč',
      titleUpdate: 'Upravit klíč'
    },
    certs: {
      title: 'Klíče',
      noCerts: 'Žádné klíče'
    },
    common: {
      title: 'Obecné nastavení',
      saved: 'Údaje uloženy'
    },
    password: {
      title: 'Změnit heslo',
      saved: 'Nové heslo uloženo',
      originalPassword: 'Původní heslo',
      newPassword: 'Nové heslo',
      newPasswordAgain: 'Nové heslo znovu',
      passwordsMustMatch: 'Hesla se musí shodovat',
      wrongOriginalPassword: 'Špatné původní heslo'
    }
  },
  user: {
    passwordsMustMatch: 'Hesla se musí shodovat',
    passwordIsTooWeak: 'Heslo je příliš slabé'
  },
  configuration: {
    basic: {
      title: 'Nastavení',
      maxAge: 'Maximální stáří nahrávek',
      maxAgeHint: 'Ve dnech, 0 vypnutí mazání',
      encrypt: 'Šifrování nahrávek',
      publicKey: 'Změnit veřejný klíč',
      password: 'Heslo',
      encryption: {
        none: 'Žádné',
        password: 'Heslem',
        key: 'Klíčem'
      },
      compression: 'Komprese',
      compressions: {
        pcm: 'PCM (Žádná)',
        flac: 'FLAC',
        mp3: 'MP3'
      },
      invalidKey: 'Nevalidní PGP klíč',
      insertIdent: 'Vložit identifikaci stažené nahrávky',
      saved: 'Nastavení uloženo'
    },
    certs: {
      title: 'Povolené klíče uživatelů',
      noCerts: 'Žádné klíče',
      addKey: {
        title: 'Přidat klíč',
        certificate: 'Klíč'
      }
    }
  },
  keyFoot: {
    keyWarning: 'Máte v paměti uložený privátní klíč',
    keyAndPassWarning: 'Máte v paměti uložený privátní klíč a heslo!',
    forget: 'Zapomenout'
  },
  player: {
    title: 'Přehrávač',
    titlePrivateKeySettings: 'Nastavení privátního klíče',
    titlePrivateKeyPass: 'Heslo klíče',
    privateKeyPrompt: 'Nahrávka je zašifrovaná. Pro dešifrování je potřeba privátní klíč:',
    privateKey: 'Privátní klíč',
    saveLocally: 'Lokálně uložit pro opakované použití',
    continue: 'Pokračovat',
    passPrompt: 'Pro dešifrování zadejte heslo k vašemu privátnímu klíči:',
    passphrase: 'Heslo',
    saveTemporary: 'Dočasně uložit',
    decrypt: 'Dešifrovat',
    forgetKey: 'Zapomenout klíč',
    download: 'Stáhnout',
    keyLoadingFailed: 'Klíč se nepodařilo načíst',
    keyRequiresPass: 'Klíč vyžaduje heslo',
    wrongPass: 'Špatné heslo',
    loadingFailed: 'Nepodařilo se načíst nahrávku',
    wrongKey: 'Nahrávku nelze pomocí tohoto klíče dešifrovat',
    decryptingInProgress: 'Probíhá dešifrování nahrávky',
    playError: 'Při načítání nahrávky došlo k chybě. Podporuje váš prohlížeč přehrávání nahrávek typu {0}?'
  },
  tagger: {
    title: 'Tagy',
    addTag: 'Vytvořit tag',
    add: 'Přidat'
  },
  reset: {
    success: 'Heslo bylo úspěšně změněno.',
    continue: 'Pokračovat',
    invalidToken: 'Žádost o změnu hesla nebyla nalezena'
  },
  forgotten: {
    description: 'Zadejte prosím vaše uživatelské jméno. Po odeslání vám přijde e-mail s dalšími instrukcemi.',
    success: 'E-mailová zpráva odeslána. Dále postupujte podle instrukcí ve zprávě.',
    send: 'Odeslat',
    failed: 'Odeslání se nezdařilo. Je zadané uživatelské jméno správné?'
  },
  crud: {
    add: 'Přidat',
    filters: 'Filtry',
    csv: 'CSV',
    delete: 'Smazat',
    edit: 'Upravit',
    deleteSelected: 'Smazat vybrané',
    filter: {
      clear: 'Vyčistit'
    },
    filterTooltip: '<b>Aktivní filtr:</b> {0}',
    refresh: 'Obnovit',
    newTitle: 'Vytvoření nové položky',
    editTitle: 'Úprava existující položky'
  },
  logicStorageReport: {
    displayFilters: 'Nastavení zobrazení',
    showOnly: 'Zobrazit pouze tuto položku'
  },
  companySetup: {
    description: 'Pro pokračování je potřeba nastavit hlavní klíč pro šifrování nahrávek',
    publicKey: 'Hlavní veřejný klíč'
  },
  delegations: {
    title: 'Delegace',
    delegatedAs: 'Delegace jako',
    expiredAlert: 'Vaše právě vybraná delegace vypršela.'
  },
  errors: {
    notEmpty: 'Nesmí být prázdné',
    mustBeLonger: 'Musí být delší než {0}',
    passwordComplexityIsLessThanCompanyGroup: 'Síla hesla je menší než síla nastavená ve skupině',
    passwordExpiryIsLessThanCompanyGroup: 'Doba expirace je větší než doba nastavená ve skupině ({0} dní)',
    invalidAutomaticIdent: 'Může obsahovat pouze znaky 1234567890+*#',
    positiveNumbersOnly: 'Pouze čísla >= 0'
  },
  titles: {
    login: 'Přihlášení',
    dashboard: 'Dashboard',
    recordings: 'Nahrávky',
    reports: {
      title: 'Reporty',
      accesses: 'Výpis přihlášení',
      dataChanges: 'Výpis změn',
      systemStorage: 'Využití systémového místa',
      logicStorage: 'Využití místa',
      notifications: 'Notifikace'
    },
    admin: {
      title: 'Správa',
      superadmins: 'Superadministrátoři',
      groupadmins: 'Administrátoři',
      companyadmins: 'Správci společnosti',
      users: 'Uživatelé',
      companies: 'Firmy',
      companyGroups: 'Skupiny firem',
      lines: 'Linky',
      lineGroups: 'Skupiny linek',
      numbers: 'Čísla',
      tags: 'Tagy',
      configuration: 'Nastavení nahrávek',
      userCertificates: 'Uživatelské klíče',
      companyDelegations: 'Delegace'
    },
    profile: 'Profil',
    logout: 'Odhlásit',
    passwordReset: 'Změnit heslo',
    forgottenPassword: 'Zapomenuté heslo',
    companySetup: 'Nastavení šifrování nahrávek'
  },
  headers: {
    user: 'Uživatel',
    ipAddress: 'IP Adresa',
    loggedIn: 'Přihlášení',
    loggedOut: 'Odhlášení',
    changeDate: 'Datum změny',
    tableName: 'Tabulka',
    operation: 'Operace',
    dataBefore: 'Data před',
    dataAfter: 'Data po',
    name: 'Název',
    description: 'Popis',
    ico: 'IČO',
    enabled: 'Aktivní',
    company: 'Firma',
    companies: 'Firmy',
    recordDaysOfWeek: 'Nahrávat ve dnech',
    recordTimeFrom: 'Nahrávat od',
    recordTimeTill: 'Nahrávat do',
    recordingType: 'Nahrávat',
    certificates: 'Klíče',
    phoneNumber: 'Číslo',
    targetGroup: 'Skupina',
    overrideGroup: 'Přepsat nastavení skupiny',
    username: 'Uživatelské jméno',
    personName: 'Jméno',
    surname: 'Příjmení',
    email: 'E-mail',
    companyGroup: 'Skupina firem',
    companyGroups: 'Skupiny firem',
    password: 'Heslo',
    passwordAgain: 'Heslo znovu',
    browser: 'Prohlížeč',
    target: 'Linka',
    callDate: 'Datum',
    source: 'Volající',
    destination: 'Volaný',
    duration: 'Délka hovoru',
    direction: 'Směr hovoru',
    state: 'Stav',
    tags: 'Tagy',
    targets: 'Linky',
    targetGroups: 'Skupiny linek',
    admins: 'Správci',
    date: 'Datum',
    actionType: 'Akce',
    recordAlways: 'Nahrávat vždy',
    createAdmin: 'Vytvořit správce',
    sendInfo: 'Odeslat informace e-mailem',
    quota: 'Kvóta místa',
    passwordComplexity: 'Vyžadovaná síla hesla',
    passwordExpiry: 'Doba vypršení hesla',
    allowRecordingDeletion: 'Povolit uživatelské mazání nahrávek',
    automaticIdent: 'Automatická identifikace',
    customLogo: 'Vlastní logo',
    customLogoHint: 'URL adresa loga firmy',
    customCss: 'Vlastní styl',
    customCssHint: 'URL adresa css stylu firmy',
    show: 'Zobrazit',
    totalSpace: 'Celkem místa',
    takenSpace: 'Zabráno',
    disabledSpace: 'Neaktivních',
    severity: 'Závažnost',
    type: 'Typ',
    text: 'Text',
    maxChannels: 'Maximalní počet kanalů',
    disableRecording: 'Zakázat nahrávání',
    changePasswordAfterLogin: 'Vynutit změnu hesla po přihlášení',
    requireEncryption: 'Vyžadovat šifrování klíčem',
    recordingsSize: 'Obsazené místo',
    allowedHosts: 'Povolit přístup z',
    allowedHostsHint: 'Seznam zdrojů ze kterých může uživatel přistupovat. Prázdný seznam povolí přístup odkudkoliv. Formát je: maska;maska;maska. Maska je pak buď hostname (example.com), ip adresa (192.168.100.1) nebo ip adresa s rozsahem (192.168.100.0/24)',
    color: 'Barva',
    dateFrom: 'Aktivní od',
    delegationDuration: 'Délka',
    delegationDurationHint: 'V minutách',
    note: 'Poznámka',
    recordingsConfirmations: 'Potvrzování nahrávek',
    sipId: 'SIP Identifikátor',
    dtmfDelectionAllowed: 'Povolit detekci DTMF',
    companyAuditor: 'Auditor'
  },
  week: {
    monday: 'Pondělí',
    tuesday: 'Úterý',
    wednesday: 'Středa',
    thursday: 'Čtvrtek',
    friday: 'Pátek',
    saturday: 'Sobota',
    sunday: 'Neděle'
  },
  time: {
    from: 'Od',
    to: 'Do'
  },
  passwordComplexity: {
    low: 'Slabší',
    medium: 'Střední',
    high: 'Vysoká'
  },
  recordingType: {
    always: 'Vždy nahrávat',
    never: 'Nikdy nenahrávat'
  },
  callDirection: {
    in: 'Dovnitř',
    out: 'Ven'
  },
  callState: {
    answered: 'Přijato',
    notAnswered: 'Nepřijato',
    busy: 'Zaneprázdněn'
  },
  space: {
    free: 'Volné místo',
    used: 'Využité místo',
    inactive: 'Využité neaktivími firmami'
  },
  userRole: {
    superAdmin: 'Superadmin',
    groupAdmin: 'Admin',
    companyAdmin: 'Admin společnosti',
    companyUser: 'Uživatel'
  },
  recordingRequests: {
    operation: {
      delete: 'Smazání',
      play: 'Přehrání',
      download: 'Stažení'
    }
  },
  companyNotifications: {
    severity: {
      debug: 'DEBUG',
      info: 'INFO',
      warn: 'VAROVÁNÍ',
      error: 'CHYBA'
    },
    type: {
      automaticTarget: 'Automatická linka',
      quotaUsage: 'Kvóty'
    },
    automaticTarget: 'Byla vytvořena linka s číslem {number}',
    quotaUsage: 'Obsazení disku dosáhlo {percentage} % kvóty'
  },
  targetsReport: {
    title: 'Využití linek',
    period: 'Období',
    defined: 'Definováno',
    used: 'Použito'
  },
  noItems: 'Žádné položky',
  loadingItems: 'Načítání dat',
  close: 'Zavřít',
  save: 'Uložit',
  create: 'Vytvořit',
  savingFailed: 'Uložení se nezdařilo',
  cancel: 'Zrušit',
  yes: 'Ano',
  no: 'Ne',
  inDays: 'Ve dnech',
  inMb: 'V MiB',
  changePasswordDescription: 'Pro dokončení přihlášení je potřeba nastavit nové heslo',
  search: 'Vyhledat'
}



// WEBPACK FOOTER //
// ./src/locale/cs.js